import { render, staticRenderFns } from "./MessageAreaHeader.vue?vue&type=template&id=ee7af43a&scoped=true"
import script from "./MessageAreaHeader.vue?vue&type=script&lang=js"
export * from "./MessageAreaHeader.vue?vue&type=script&lang=js"
import style0 from "./MessageAreaHeader.vue?vue&type=style&index=0&id=ee7af43a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7af43a",
  null
  
)

export default component.exports